import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody } from '../../../../components/card/card';
import { GetPersonlListWithPayrol } from '../../../../store/HR/Payroll/runPayrollSlice';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import Loading from '../../../../components/Shared/Loader/Loading';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import AddQuickPay from './AddQuickPay';
import NtxTable from '../../../../components/DataTable/NtxTable';

const QuickPay = () => {
  const { t, i18n } = useTranslation();

  // const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [person, setPerson] = useState();

  const { PersonlListWithPayrol, loading, error } = useSelector((state) => state.runPayroll);

  useEffect(() => {
    if (PersonlListWithPayrol?.length === 0) {
      dispatch(GetPersonlListWithPayrol());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  //_____________________

  const columns = [
    { title: t('EmployeeName'), key: 'Name' },
    { title: t('EmployeeNumber'), key: 'num' },
    { title: t('Payroll'), key: 'Payroll' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false },
  ];

  const tableData = PersonlListWithPayrol?.map((item) => {
    return {
      Name: i18n.language === 'ar' ? item.personName2 : item.personName,
      num: item.employeeNumber,
      Payroll: i18n.language === 'ar' ? item.payrollName2 : item.payrollName,
      action: (
        <>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#CreateQuickPay"
            onClick={() => setPerson(item)}
            className="btn btn-sm btn-outline-theme">
            <i className="fas fa-lg fa-fw me-2 fa-money-bill-alt"></i>
            {t('QuickPay')}
          </button>
        </>
      ),
    };
  });

  const titleModal = () => {
    return (
      <div className="">
        {t('QuickPay')}
        {'  '}
        <span className="text-theme ms-2">
          {`${i18n.language === 'en' ? person?.personName : person?.personName2}`}
        </span>
      </div>
    );
  };

  //____________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },

    {
      name: t('QuickPay'),
      link: null,
    },
  ];

  return (
    <>
      <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('QuickPay')} />
      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent id="CreateQuickPay" title={titleModal()} size="lg">
        {person && <AddQuickPay person={person} />}
      </ModalComponent>
    </>
  );
};

export default QuickPay;
